import { render, staticRenderFns } from "./AreaForm.vue?vue&type=template&id=267f6606&scoped=true&"
import script from "./AreaForm.vue?vue&type=script&lang=js&"
export * from "./AreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f6606",
  null
  
)

export default component.exports